<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new">
      <i class="fa-solid fa-sliders"></i>
    </div>
    <div>
      <h2 class="dialog-title">Filter Production Requests</h2>
      <p class="dialog-subtitle">Set criteria to filter results</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onCancel()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <form [formGroup]="filtersForm" class="dialog-form-grid">
    <!-- Client -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Client</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="client" placeholder="Enter client">
      </mat-form-field>
    </div>

    <!-- Name -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Name</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="name" placeholder="Enter name">
      </mat-form-field>
    </div>

    <!-- Request Id -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Request Id</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="requestId" placeholder="Enter request ID">
      </mat-form-field>
    </div>

    <!-- Master Commercial Ref Code -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Master Commercial Ref Code</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="masterCommercialRefCode" placeholder="Enter reference code">
      </mat-form-field>
    </div>

    <!-- Creator/Owner -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Creator/Owner</mat-label>
      <mat-form-field appearance="outline">
        <input
          type="text"
          matInput
          formControlName="creatorOwner"
          placeholder="Type to search user"
          [matAutocomplete]="acOwner">
        <mat-autocomplete #acOwner="matAutocomplete">
          @for( owner of filteredOwners | async; track owner ) {
            <mat-option [value]="owner">{{ owner }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <!-- TxId -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">TxId</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="txId" placeholder="Enter Tx ID">
      </mat-form-field>
    </div>

    <!-- Created From/To -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Created From/To</mat-label>
      <mat-form-field appearance="outline">
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate formControlName="createdFrom" placeholder="Start date" readonly>
          <input matEndDate formControlName="createdTo" placeholder="End date" readonly>
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>

    <!-- Limit -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Limit</mat-label>
      <mat-form-field appearance="outline">
        <input matInput type="number" formControlName="resultLimit" placeholder="Enter limit" min="1">
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button class="btn-ghost" (click)="onCancel()">Cancel</button>
  <button class="btn-ghost" (click)="onClear()">Clear Filters</button>
  <button class="btn-blue" (click)="onApply()">Apply Filters</button>
</mat-dialog-actions>
